import { Button, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import React, { useState } from "react";
import BlkFormik from "../coms/BlkFormik";
import { FieldArray } from "formik";
import { ArchivoUpload } from "../coms/ArchivoUpload";
import { BlkField } from "../coms/BlkField";
import { routes } from "../gen/General";
import axios from "axios";
import { useSelector } from "react-redux";
import Alerts from "../util/Alerts";

export const ModalUploadDocs = ({ toggleModal, open, datos, onClose }) => {
    const [documentos, setDocumentos] = useState();
    const user = useSelector(state => state.user);
    const alert = React.useRef();

    const closeModal = () => {
        toggleModal(false);
        onClose && onClose();
    };

    const onSubmit = (values, actions) => {
        let formData = new FormData();
        let _values = JSON.parse(JSON.stringify(values));
        (values.items || []).forEach(it => {
            formData.append("files", it.doc, it.name);
        });

        (_values.items || []).forEach(it => {
            it.doc = undefined;
        });
        formData.append("item", new Blob([JSON.stringify(_values)], { type: "application/json" }));

        // en memoria se vacia los archivos
        (values.items || []).forEach(it => {
            it.doc = "";
        });
        const current = alert.current;
        saveFilesToZoho(formData);
        axios
            .post(routes.api + "/docs", formData, {
                headers: {
                    "content-Type": "multipart/form-data",
                },
            })
            .then(resp => {
                let data = resp.data;
                setDocumentos({ documento: data, edit: false });
                current.show_info("Se ha subido correctamente el documento");
                setTimeout(closeModal, 3000);
                actions.setSubmitting(false);
            })
            .catch(error => {
                current.handle_error("Error al subir el documento");
            })
            .then(() => {
                actions.setSubmitting(false);
            });
    };

    const saveFilesToZoho = formData => {
        axios.post(routes.apiVam + "/docs-to-zoho", formData, { headers: { "content-Type": "multipart/form-data" } });
    };

    return (
        <div>
            <Modal className="text-center modal-dialog-centered modal-lg" isOpen={open}>
                <ModalHeader className="justify-content-center title" tag="h4">
                    Carga de Documentos
                    <button type="button" className="close" title="Cerrar" onClick={closeModal} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                <Alerts ref={alert} />
                <ModalBody className={"pt-0 mt-0"}>
                    <div className="container-fluid container-md">
                        <BlkFormik
                            initialValues={datos}
                            onSubmit={onSubmit}
                            enableReinitialize={true}
                            validateOnChange={false}
                        >
                            {({ values, isSubmitting, submitForm, setFieldValue }) => (
                                <>
                                    <FieldArray name="items">
                                        {({ push, remove }) => (
                                            <>
                                                {(values.items || []).map((documentos, index) => (
                                                    <>
                                                        <div className="form-group">
                                                            <small>
                                                                <Label className="media text-primary">Nombre: </Label>
                                                            </small>
                                                            <Row>
                                                                <div className="col-lg-6 ">
                                                                    <BlkField
                                                                        name={`items[${index}].metadato.dsc`}
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="Nombre Documento"
                                                                        autoFocus={true}
                                                                    />
                                                                </div>
                                                                <div className="col-lg-6" key={index}>
                                                                    <div className="actions pull-right">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-primary"
                                                                            onClick={() => {
                                                                                if (values.items.length === 1) {
                                                                                    remove(index);
                                                                                    push(addDocumentos());
                                                                                } else {
                                                                                    remove(index);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className="fas fa-trash-alt m-1"
                                                                                title={"Eliminar"}
                                                                            />
                                                                            <span className="m-1">Eliminar</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </Row>
                                                            <br />
                                                            <div className={" form-group "}>
                                                                <ArchivoUpload
                                                                    id={"files"}
                                                                    values={values.items[index]}
                                                                    index={index}
                                                                    setFieldValue={setFieldValue}
                                                                    usuario={user}
                                                                />
                                                            </div>
                                                            <hr className={"border border-bottom border-primary"} />
                                                        </div>
                                                    </>
                                                ))}
                                                <Row>
                                                    {(values.items || []).length < 10 && (
                                                        <Button
                                                            color="yellow"
                                                            className="btn btn-sm mx-xl-2"
                                                            onClick={() => push(addDocumentos())}
                                                        >
                                                            <i className={"fa fa-plus m-1"} />
                                                            Agregar Documento
                                                        </Button>
                                                    )}
                                                </Row>
                                            </>
                                        )}
                                    </FieldArray>
                                    <Button
                                        type={"submit"}
                                        color="primary"
                                        className=" mb-3 mt-lg-n5 mx-2"
                                        onClick={submitForm}
                                        disabled={isSubmitting}
                                    >
                                        Guardar Documentos
                                    </Button>
                                </>
                            )}
                        </BlkFormik>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};
export const addDocumentos = () => {
    return {
        doc: "",
        index: "",
        name: "",
        metadato: {
            fecha: "",
            idUsuario: "",
            username: "",
            dsc: "",
        },
    };
};
